export default __webpack_public_path__ + "static/media/product-file.016009fa.svg";